import { Clock3 } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Badge, type BadgeTone } from '@/components/ui';
import type { AgeingBucket } from './api';

const tones: Record<AgeingBucket, BadgeTone> = {
  '0_30': 'success',
  '31_60': 'info',
  '61_90': 'warning',
  '90_plus': 'danger',
};

export function AgeingIndicator({
  bucket,
  days,
}: {
  bucket: AgeingBucket;
  days: number;
}) {
  const { t } = useTranslation();
  return (
    <Badge tone={tones[bucket]} icon={<Clock3 size={13} />}>
      {t(`panelReceivables.ageing.${bucket}`)} ·{' '}
      {t('panelReceivables.daysOutstanding', { count: days })}
    </Badge>
  );
}
